module.exports = __webpack_public_path__ + "static/media/NimbusSanL-Med.b35e5288.woff";